import * as z from 'zod';

// Types
import { SelectOptionZod } from '@/types/SelectOptionType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const JobApplicationFormZod = z.object({
  __component: z.literal('block.form-job-application'),
  id: z.number(),
  title: TitleZod,
  paragraph: ParagraphZod,
  waveWrapper: WaveWrapperZod.nullable(),
});

export type JobApplicationFormType = z.infer<typeof JobApplicationFormZod>;

const JobApplicationFormConfigZod = z.object({
  id: z.number(),
  documentId: z.string(),
  type: z.array(SelectOptionZod),
  dreamJob: z.array(SelectOptionZod),
});

export type JobApplicationFormConfigType = z.infer<typeof JobApplicationFormConfigZod>;

export const JobApplicationFormValidationZod = z.object({
  firstname: z.string().min(1, { message: 'Le prénom est requis' }),
  lastname: z.string().min(1, { message: 'Le nom est requis' }),
  email: z
    .string()
    .min(1, { message: 'L’adresse email est requise' })
    .trim()
    .pipe(z.email({ message: 'L’adresse email est invalide' })),
  phone: z.string().optional(),
  comment: z.string().optional(),
  marketingConsent: z.boolean().refine((val) => val === true, { message: 'Le consentement est requis' }),
  files: z.array(z.instanceof(File)).optional(),
  type: z.string().optional(),
  dreamJob: z.string().optional(),
});

export type JobApplicationFormValidationType = z.infer<typeof JobApplicationFormValidationZod>;

export { JobApplicationFormZod, JobApplicationFormConfigZod };
